module Meevo.Plugins.AlertsManager {

    class SingleSpinnerConfigComponent extends BaseConfigComponent implements ng.IComponentController {

        static $inject = [
            'meevo.plugins.alertsManager.AlertsManagerService'
        ];

        public params: IParams;
        public data: ISingleSpinnerData;

        public selectedValue: number;

        get dataForReview() {
            return [
                this.selectedValue
            ];
        }

        get alertConfiguration() {
            return {
                [this.data.configKey]: this.selectedValue
            }
        }

        $onInit() {
            this.selectedValue = this.data.default || 1;

            super.$onInit();
        }

        onEdit(alertJSON: Object): void {
            this.selectedValue = alertJSON[this.data.configKey];
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoSingleSpinnerConfigComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/config-components/single-spinner-config/single-spinner-config.component.html',
            controller: SingleSpinnerConfigComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<',
                data: '<'
            }
        });
}
